import React from "react";
import styles from "../../assets/styles/_product.module.scss";
import thumbProduct1 from "../../assets/images/productPage/product-bottle.png";
import thumb1Product1 from "../../assets/images/productPage/product-bottle1.png";
import thumb2Product1 from "../../assets/images/productPage/product-bottle2.png";
import thumb3Product1 from "../../assets/images/productPage/product-bottle3.png";
import thumb4Product1 from "../../assets/images/productPage/product-bottle4.png";
import thumb5Product1 from "../../assets/images/productPage/product-bottle5.png";
import thumbProduct2 from "../../assets/images/productPage/thumbProduct2.png";
import thumb1Product2 from "../../assets/images/productPage/thumb1Product2.png";
import thumb2Product2 from "../../assets/images/productPage/thumb2Product2.png";
import thumb3Product2 from "../../assets/images/productPage/thumb3Product2.png";
import thumb4Product2 from "../../assets/images/productPage/thumb4Product2.png";
import thumb5Product2 from "../../assets/images/productPage/thumb5Product2.png";
import baseCareBottle from "../../assets/images/productPage/thumb6Product2.webp";
import baseCareCard1 from "../../assets/images/products/cardMist1.png";
import baseCareCard2 from "../../assets/images/products/cardMist2.png";
import baseCareCard3 from "../../assets/images/products/cardMist3.png";
import baseCareCardMb from "../../assets/images/products/cardMist_mb.png";
import FadeInSection from "../common/FadeInSection";
import BtnLearnMore from "../common/btnLearnMore";
import Breadcrumb from "../common/breadcrum";
import { useNavigate } from "react-router-dom";

const ProductPageComponent = () => {
  const navigate = useNavigate();

  const DeepProduct = [
    {
      id: 1,
      thumb: thumbProduct1,
      title1: "ウォーターコートシャンプー",
      title2: "ディープモイスト",
      capacity: "1,540",
      volume: "450mL",
    },
    {
      id: 1,
      thumb: thumb1Product1,
      title1: "ウォーターコートトリートメント",
      title2: "ディープモイスト",
      capacity: "1,540",
      volume: "450g",
    },
    {
      id: 1,
      thumb: thumb2Product1,
      title1: "ウォーターコートヘアオイル",
      title2: "ディープモイスト",
      capacity: "1,540",
      volume: "100mL",
    },
    {
      id: 1,
      thumb: thumb3Product1,
      title1: "ウォーターコートヘアミルク",
      title2: "ディープモイスト",
      capacity: "1,540",
      volume: "150g",
    },
    {
      id: 1,
      thumb: thumb4Product1,
      title1: "ウォーターコートシャンプー 詰替",
      title2: "ディープモイスト",
      title1_mb: "ウォーターコートシャンプー",
      title2_mb: "詰替 ディープモイスト",
      capacity: "1,210",
      volume: "380mL",
    },
    {
      id: 1,
      thumb: thumb5Product1,
      title1: "ウォーターコートトリートメント 詰替",
      title2: "ディープモイスト",
      title1_mb: "ウォーターコートトリートメント",
      title2_mb: "詰替 ディープモイスト",
      capacity: "1,210",
      volume: "380g",
    },
  ];
  const SleekProduct = [
    {
      id: 1,
      thumb: thumbProduct2,
      title1: "ウォーターコートシャンプー",
      title2: "スリークモイスト",
      capacity: "1,540",
      volume: "450mL",
    },
    {
      id: 1,
      thumb: thumb1Product2,
      title1: "ウォーターコートトリートメント",
      title2: "スリークモイスト",
      capacity: "1,540",
      volume: "450g",
    },
    {
      id: 1,
      thumb: thumb2Product2,
      title1: "ウォーターコートヘアオイル",
      title2: "スリークモイスト",
      capacity: "1,540",
      volume: "100mL",
    },
    {
      id: 1,
      thumb: thumb3Product2,
      title1: "ウォーターコートヘアミルク",
      title2: "スリークモイスト",
      capacity: "1,540",
      volume: "150g",
    },
    {
      id: 1,
      thumb: thumb4Product2,
      title1: "ウォーターコートシャンプー 詰替",
      title2: "スリークモイスト",
      title1_mb: "ウォーターコートシャンプー ",
      title2_mb: "詰替 スリークモイスト",
      capacity: "1,210",
      volume: "380mL",
    },
    {
      id: 1,
      thumb: thumb5Product2,
      title1: "ウォーターコートトリートメント 詰替",
      title2: "スリークモイスト",
      title1_mb: "ウォーターコートトリートメント ",
      title2_mb: "詰替 スリークモイスト",
      capacity: "1,210",
      volume: "380g",
    },
  ];
  return (
    <div className={styles.productPage}>
      <FadeInSection>
        <div className={styles.productTitle}>PRODUCT</div>
      </FadeInSection>
      {/* Product Deep Section */}
      <div className={`${styles.productContent} ${styles.left}`}>
        <div className={styles.bgr}></div>
        <FadeInSection>
          <div className={styles.productContentType}>
            <div className={styles.small}>
              普通<span>から</span>
            </div>
            <div className={styles.big}>太髪</div>
            <div className={styles.small}>用</div>
          </div>
          <div className={styles.productContentTop}>
            <div className={styles.productContentDesc}>
              うねる髪がまとまり 毛先つるん髪
            </div>
            <div className={styles.productContentTitle}>DEEP MOIST</div>
            <div className={styles.productContentDescEnd}>
              ディープモイストシリーズ（太髪の方）
            </div>
          </div>
        </FadeInSection>
        <div className={styles.paddingTop}></div>
        <div className={styles.productList}>
          {DeepProduct.map((itemDeep) => {
            return (
              <div className={styles.item} key={itemDeep.id}>
                <FadeInSection>
                  <div className={styles.thumb}>
                    <img src={itemDeep.thumb} />
                  </div>
                  <div className={styles.itemTitle}>
                    {itemDeep.title1_mb && window.innerWidth < 576
                      ? itemDeep.title1_mb
                      : itemDeep.title1}
                    <br />
                    {itemDeep.title2_mb && window.innerWidth < 576
                      ? itemDeep.title2_mb
                      : itemDeep.title2}
                  </div>
                  <div className={styles.capacity}>
                    {itemDeep.capacity}
                    <span>円(税込)</span>{" "}
                    <div className={styles.volume}>{itemDeep.volume}</div>
                  </div>
                </FadeInSection>
              </div>
            );
          })}
        </div>
        <FadeInSection>
          <div className={styles.btn}>
            <BtnLearnMore
              color=""
              baseColor=""
              action={() => navigate("/product-detail-deep")}
            >
              LEARN MORE
            </BtnLearnMore>
          </div>
        </FadeInSection>
      </div>
      {/* Product Sleek Section */}
      <div className={`${styles.productContent} ${styles.right}`}>
        <div className={styles.bgr}></div>
        <FadeInSection>
          <div className={styles.productContentType}>
            <div className={styles.small}>
              普通<span>から</span>
            </div>
            <div className={styles.big}>細髪</div>
            <div className={styles.small}>用</div>
          </div>
          <div className={styles.productContentTop}>
            <div className={styles.productContentDesc}>
              からまる髪がサラサラ 毛先するん髪
            </div>
            <div className={styles.productContentTitle}>SLEEK MOIST</div>
            <div className={styles.productContentDescEnd}>
              スリークモイストシリーズ（細髪の方）
            </div>
          </div>
        </FadeInSection>
        <div className={styles.paddingTop}></div>
        <div className={styles.productList}>
          {SleekProduct.map((item) => {
            return (
              <div className={styles.item} key={item.id}>
                <FadeInSection>
                  <div className={styles.thumb}>
                    <img src={item.thumb} />
                  </div>
                  <div className={styles.itemTitle}>
                    {item.title1_mb && window.innerWidth < 576
                      ? item.title1_mb
                      : item.title1}
                    <br />
                    {item.title2_mb && window.innerWidth < 576
                      ? item.title2_mb
                      : item.title2}
                  </div>
                  <div className={styles.capacity}>
                    {item.capacity}
                    <span>円(税込)</span>{" "}
                    <div className={styles.volume}>{item.volume}</div>
                  </div>
                </FadeInSection>
              </div>
            );
          })}
        </div>
        <FadeInSection>
          <div className={styles.btn}>
            <BtnLearnMore
              color=""
              baseColor=""
              action={() => navigate("/product-detail-sleek")}
            >
              LEARN MORE
            </BtnLearnMore>
          </div>
        </FadeInSection>
      </div>
      {/* Product Mist Section */}
      <div className={`${styles.productContent} ${styles.left} ${styles.baseCare}`}>
        <div className={styles.bgr}></div>
        <FadeInSection>
          <div className={styles.productContentType}>
            <div className={styles.small}>太髪/細髪</div>
            <div className={styles.big}>共通</div>
          </div>
          <div className={styles.productContentTop}>
            <div className={styles.productContentDesc}>髪の土台を整える</div>
            <div className={styles.productContentTitle}>BASE CARE</div>
            <div className={styles.productContentDescEnd}>
              ベースケアシリーズ（太髪/細髪共通）
            </div>
          </div>
        </FadeInSection>
        <div className={styles.baseCareMain}>
          <FadeInSection>
            <div className={styles.baseCareBottle}>
              <img src={baseCareBottle} alt="Water Serum Hair Mist" />
            </div>
            <div className={styles.baseCareNameEn}>
              WATER SERUM HAIR MIST
              <br />
              BASE CARE
            </div>
            <div className={styles.baseCarePrice}>
              <span className={styles.baseCarePriceValue}>1,540</span>
              <span>円</span>
              <span className={styles.baseCareVolume}>220mL</span>
            </div>
          </FadeInSection>
        </div>
        <FadeInSection>
          <div className={styles.baseCareCatchTop}>\ 　片手でシュッ！　/</div>
          <div className={styles.baseCareCatchMain}>
            ベタつかないのにサラサラ髪に！
          </div>
        </FadeInSection>
        <div className={styles.baseCareCards}>
          <div className={`${styles.baseCareCard} ${styles.baseCareCard1}`}>
            <FadeInSection>
              <img src={baseCareCard1} alt="" className={styles.imgDesktop} />
              <img src={baseCareCardMb} alt="" className={styles.imgMobile} />
            </FadeInSection>
          </div>
          <div className={`${styles.baseCareCard} ${styles.baseCareCard2}`}>
            <FadeInSection>
              <img src={baseCareCard2} alt="" />
            </FadeInSection>
          </div>
          <div className={`${styles.baseCareCard} ${styles.baseCareCard3}`}>
            <FadeInSection>
              <img src={baseCareCard3} alt="" />
            </FadeInSection>
          </div>
        </div>
      </div>

      <Breadcrumb
        data={[
          {
            title: "TOP",
            link: "/",
          },
          {
            title: "PRODUCTS",
            link: "/products",
          },
        ]}
      />
    </div>
  );
};

export default ProductPageComponent;
